import React, { useEffect, useState } from 'react';
import { 
  WelcomeSliderContainer, 
  WelcomeSliderContent, 
  WelcomeSliderModal,
  WelcomeSliderHeader,
  WelcomeSliderBody,
  WelcomeSliderFooter,
  WelcomeSliderBodyTitle,
  WelcomeSliderBodyText,
  WelcomeSliderBodyStepsContent,
  WelcomeSliderBodyStep,
  WelcomeSliderButton,
  WelcomeSliderImage
 } from './styles';
 import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';
import { welcomeSliderSteps } from '../../helpers/enum';

const WelcomeSlider = ({ setShow }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [stepToFade, setStepToFade] = useState(0);
  const [fade, setFade] = useState(true);

  function changeStep(key) {
    setActiveStep(key);
    setFade(false);

    setTimeout(() => {
      setStepToFade(key)
      setFade(true);
    }, 200)
  }

  return (
    <WelcomeSliderContainer>
      <WelcomeSliderContent>
        <WelcomeSliderModal>
          <WelcomeSliderHeader>
            <IoClose size={26} color={colors.textSecondary} onClick={() => setShow(false)}/>
          </WelcomeSliderHeader>
          <WelcomeSliderBody>
            <WelcomeSliderImage src={welcomeSliderSteps[stepToFade].image} alt="multidevice" show={fade} />
            <WelcomeSliderBodyTitle show={fade}>
              {welcomeSliderSteps[stepToFade].title}
            </WelcomeSliderBodyTitle>
            <WelcomeSliderBodyText show={fade}>
              {welcomeSliderSteps[stepToFade].description}
            </WelcomeSliderBodyText>
            <WelcomeSliderBodyStepsContent>
              {welcomeSliderSteps.map((step, key) => (
                <WelcomeSliderBodyStep key={key} active={key === activeStep} onClick={() => changeStep(key)} />
              ))}
            </WelcomeSliderBodyStepsContent>
          </WelcomeSliderBody>
          <WelcomeSliderFooter>
            <WelcomeSliderButton onClick={() => setShow(false)}>Saltar</WelcomeSliderButton>
          </WelcomeSliderFooter>
        </WelcomeSliderModal>
      </WelcomeSliderContent>
    </WelcomeSliderContainer>
  )
}

export default WelcomeSlider;
